import { render } from "./NewCustomerService.vue?vue&type=template&id=48ee75a0&scoped=true"
import script from "./NewCustomerService.vue?vue&type=script&lang=js"
export * from "./NewCustomerService.vue?vue&type=script&lang=js"

import "./NewCustomerService.vue?vue&type=style&index=0&id=48ee75a0&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ee75a0"]])

export default __exports__